/** Permission queries implemented by this bridge on both sides of the sandbox. */
export const permissionNames: readonly string[] = ["geolocation", "camera", "microphone", "notifications"];
